export default __webpack_public_path__ + "static/media/snapshot.23a1c5b5.png";